import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-delete-department',
    templateUrl: './delete-department.component.html',
    styleUrls: ['./delete-department.component.scss'],
    standalone: false
})
export class DeleteDepartmentComponent implements OnInit {
  id: number;

  constructor(public dialogRef: MatDialogRef<DeleteDepartmentComponent>,
              private dataService: DataService,
              private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any) {
                this.id = data.id;
              }

  ngOnInit(): void {
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  deleteDepartment() {
    this.dataService.delete('department/DeleteDepartment/' + this.id).then((data: any) => {
      if (data.statusCode === 200) {
        this.dialogRef.close('delete');
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Department deleted successfully',
            buttonText: 'Ok'
          }
        });
      } else if (data.statusCode === 616) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Unable to delete this department because it has related data!',
            buttonText: 'Ok'
          }
        });
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

}
